import {
  buildPaymentSummaryQuery,
  hasRequiredFilterKeys,
  paymentSummaryCardsFromResponse,
} from "@/components/receipt-payment-summary/payment-summary-factory";
import type {
  PaymentSummaryCardView,
  PaymentSummaryResponse,
} from "@/components/receipt-payment-summary/types";

export const NIYAAZ_SUMMARY_QUERY_KEYS = ["eventId", "q", "timePeriod"] as const;

export type NiyaazSummaryQueryKey = (typeof NIYAAZ_SUMMARY_QUERY_KEYS)[number];

export const NIYAAZ_PAYMENT_SUMMARY_PATH = "niyaazReceipts/summary/payment-mode";

/** Summary only after an event is chosen (Accounts filter or Events route). */
export const NIYAAZ_SUMMARY_REQUIRED_KEYS = ["eventId"] as const;

export function buildNiyaazSummaryQuery(filterValues: Record<string, unknown>): URLSearchParams {
  return buildPaymentSummaryQuery(filterValues, NIYAAZ_SUMMARY_QUERY_KEYS);
}

export function shouldFetchNiyaazPaymentSummary(filterValues: Record<string, unknown>): boolean {
  return hasRequiredFilterKeys(filterValues, NIYAAZ_SUMMARY_REQUIRED_KEYS);
}

/** Prefer list filter; fall back to Events nested route id. */
export function resolveNiyaazSummaryEventId(
  filterValues: Record<string, unknown>,
  routeEventId?: string | null
): string | undefined {
  const fromFilter = filterValues.eventId;
  if (fromFilter != null && String(fromFilter).trim() !== "") {
    return String(fromFilter).trim();
  }
  if (routeEventId != null && String(routeEventId).trim() !== "") {
    return String(routeEventId).trim();
  }
  return undefined;
}

export function withResolvedNiyaazEventId(
  filterValues: Record<string, unknown>,
  routeEventId?: string | null
): Record<string, unknown> {
  const eventId = resolveNiyaazSummaryEventId(filterValues, routeEventId);
  return eventId ? { ...filterValues, eventId } : { ...filterValues };
}

export function niyaazPaymentSummaryCardsFromResponse(
  summary: PaymentSummaryResponse
): PaymentSummaryCardView[] {
  return paymentSummaryCardsFromResponse(summary);
}
